import { Path } from '@/main/router/routerPath';

import Snimani from './Snimani.vue';
import List from './List.vue';
import Edit from './Edit.vue';
import { NAME, SNIMANIE_CASU, CRUMB_LABEL_KEY, SNIMANIE_CASU_CRUMB_LABEL_KEY } from './constants';

const CasovaUdalost = new Path(NAME, { List, Edit }, CRUMB_LABEL_KEY);
export const router = CasovaUdalost.addChildren([{
	path: `${SNIMANIE_CASU}`,
	component: Snimani,
	meta: { objectName: SNIMANIE_CASU_CRUMB_LABEL_KEY },
	name: SNIMANIE_CASU,
	props: true,
}]);
